<script setup>
import { message } from 'ant-design-vue';
import { ref } from 'vue';
import { useRouter } from "vue-router";
import BackgroundPC from "../assets/img/bacdground_pc.png";
import { useAdminStore } from "../stores/admin";
const loading = ref(false)

const email = ref('')
const password = ref('')
const AdminStore = useAdminStore()
const $router = useRouter()
const login = async () => {
  if (email.value && password.value) {
    loading.value = true
    const result = await AdminStore.login({ email: email.value, password: password.value })
    if (result.state === 'SUCCESS') $router.push('/admin')
    else console.log(result.message)
  }
  else {
    loading.value = false
    message.warning('帳號或密碼未填寫')
  }
}

const loginWithGoogle = async () => {
  await AdminStore.loginWithGoogle()
}
</script>

<template>
  <div class="view-login" :style="{ backgroundImage: `url(${BackgroundPC})` }">
    <h1>管理員登入</h1>
    <form>
      <a-input v-model:value="email" placeholder="輸入帳號" size="large" />
      <a-input-password v-model:value="password" placeholder="輸入密碼" size="large" />
      <div>
        <a-button size="large" @click="$router.push('/')">回查詢系統首頁</a-button>
        <a-button type="primary" size="large" :loading="loading" @click="login">登入</a-button>
      </div>
    </form>
  </div>
</template>
